import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative md:min-h-[90vh] flex items-center pt-10 pb-10 md:pt-20 md:pb-16 overflow-hidden" data-id="element-52">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative z-10" data-id="element-53">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-54">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-55">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-medium text-charcoal leading-tight mb-4 md:mb-6" data-id="element-56">
              FUERZA POST-PARTO 21:{' '}
              <span className="italic text-rosegold" data-id="element-57">
                Recupera tu Suelo Pélvico y Cierra tu Diástasis en 15 Minutos
              </span>
            </h1>
            <p className="text-base md:text-xl text-charcoal/80 mb-6 md:mb-10 leading-relaxed" data-id="element-58">
              Detén las fugas de orina y recupera un abdomen firme con el
              Protocolo de Micro-Hipopresivos diseñado para mamás sin tiempo.
            </p>

            <motion.div initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.15,
            ease: 'easeOut'
          }} className="relative lg:hidden mb-6" data-id="element-59">
              <div className="absolute inset-0 bg-blush rounded-full blur-3xl opacity-50 transform scale-110" data-id="element-60"></div>
              <img src="https://cdn.magicpatterns.com/uploads/3ABnAPTvWwTkG6Mg4JrosT/Ps-mk.png" alt="Fuerza Post-Parto 21 Guide" loading="lazy" decoding="async" className="relative z-10 w-full max-w-xs mx-auto drop-shadow-2xl rounded-lg" data-id="element-61" />
            </motion.div>

            <CTAButton data-id="element-62">¡SÍ, QUIERO RECUPERAR MI FUERZA!</CTAButton>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.7,
          delay: 0.15,
          ease: 'easeOut'
        }} className="relative hidden lg:block" data-id="element-63">
            <div className="absolute inset-0 bg-blush rounded-full blur-3xl opacity-50 transform scale-110" data-id="element-64"></div>
            <img src="https://cdn.magicpatterns.com/uploads/3ABnAPTvWwTkG6Mg4JrosT/Ps-mk.png" alt="Fuerza Post-Parto 21 Guide" loading="lazy" decoding="async" className="relative z-10 w-full max-w-md mx-auto drop-shadow-2xl rounded-lg" data-id="element-65" />
          </motion.div>
        </div>
      </div>
    </section>;
}